import { Component, inject, AfterViewInit } from '@angular/core';
import { AppService } from '../../services/app.service';
import { NotificationsService } from '../../services/notifications.service';

import { TippyDirective } from '@ngneat/helipopper';

@Component({
  selector: 'app-notifications',
  imports: [TippyDirective],
  templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements AfterViewInit {
  service = inject(AppService);
  notificationService = inject(NotificationsService);

  ngAfterViewInit(): void {
    if (this.notificationService.apiCalled()) return;
    this.service.isUserLoggedIn() &&
      this.notificationService.getAllNotifications();
  }
}
